import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
// import ForgotPassword from "./ForgotPassword";
import { isAuthenticated } from "../helpers/authUtils";
//import LuminateLogo from "assets/images/logo.png";
// var LuminateLogo = "https://sidmach.com/wp-content/uploads/2024/02/sidmach-logo-A.png";
import StAlbertLogo from "assets/images/StAlbertLogo.png";

import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import IntlMessages from "util/IntlMessages";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  hideMessage,
  showAuthLoader,
  adminSignIn,
  updateUsermode,
} from "actions/Auth";

class AdminSignin extends React.Component {
  constructor() {
    super();
    this.state = {
      email: "",
      password: "",
    };
  }
  componentDidMount() {
    this.props.updateUsermode("Staff");
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 400);
    }
    if (isAuthenticated(this.props.authUser)) {
      this.props.history.push("/admin/dashboard");
    }
  }
  componentDidUpdate() {
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 400);
    }
    if (isAuthenticated(this.props.authUser)) {
      this.props.history.push("/admin/dashboard");
    }
  }

  render() {
    const { email, password } = this.state;
    const { showMessage, loader, alertMessage } = this.props;
    // ("history", this.props.history);
    return (
      <div className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
        <div className="app-login-main-content">
          <div
            className="app-logo-content d-flex align-items-center justify-content-center"
            style={{
              // backgroundColor: "#f9af16",
              backgroundColor: "#B78E2D",
              padding: "10px 15px 10px 10px", // Slightly more padding on the right
              borderRadius: "4px",
              // marginLeft: '-15px'
            }}
          >
            <Link className="logo-lg" to="../" title="Luminate">
              <img
                src={StAlbertLogo}
                alt="StAlbertLogo"
                title="StAlbertLogo"
                className="img-fluid"
              />
            </Link>
          </div>

          <div className="app-login-content">
            <div className="app-login-header mb-4">
              <h1>Admin Login</h1>
              <h6 className="d-flex align-items-center justify-content-center p-1" style={{ color: "#B78E2D" }}>
                This is an admin only account
              </h6>
            </div>

            <div className="app-login-form">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  this.props.showAuthLoader();
                  this.props.adminSignIn({ email, password });
                }}
              >
                <fieldset>
                  <TextField
                    label={<IntlMessages id="appModule.email" />}
                    variant="outlined"
                    size="small"
                    fullWidth
                    onChange={(event) =>
                      this.setState({ email: event.target.value })
                    }
                    defaultValue={email}
                    margin="normal"
                    type="email"
                    className="mt-1 my-sm-3"
                    required
                  />
                  <TextField
                    type="password"
                    label={<IntlMessages id="appModule.password" />}
                    
                    variant="outlined"
                    size="small"
                    fullWidth
                    onChange={(event) =>
                      this.setState({ password: event.target.value })
                    }
                    defaultValue={password}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    required
                  />

                  <div className="mb-3 d-flex align-items-center justify-content-between">
                    <Button
                      type="submit"
                      variant="contained"
                      style={{ backgroundColor: "#B78E2D", color: "#ffffff" }}
                    >
                      <IntlMessages id="appModule.signIn" />
                    </Button>

                    <Link to="./ForgotPassword">
                      <IntlMessages id="appModule.forgotPassword" />
                    </Link>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
        {loader && (
          <div className="loader-view">
            <CircularProgress />
          </div>
        )}
        {showMessage && NotificationManager.error(alertMessage)}
        <NotificationContainer />
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const { loader, alertMessage, showMessage, adminUser } = auth;
  const authUser = adminUser;
  return { loader, alertMessage, showMessage, authUser };
};

export default connect(mapStateToProps, {
  adminSignIn,
  hideMessage,
  showAuthLoader,
  updateUsermode,
})(AdminSignin);
